/* eslint-env browser */
import startCase from "lodash/startCase";

export default function useStatusClasses(controller, identifier) {
  const stylableElements = [
    controller.element,
    ...controller.element.querySelectorAll(`[data-stylable='${identifier}']`),
  ];

  Object.assign(controller, {
    stylableElements,

    updateStatusClasses(status, previousStatus) {
      const previousStatusClassKey = startCase(previousStatus).replaceAll(" ", "");
      const statusClassKey = startCase(status).replaceAll(" ", "");

      this.stylableElements.forEach((element) => {
        element.classList.remove(...(element.dataset?.[`statusClasses${previousStatusClassKey}`]?.split(" ") || []));
        element.classList.add(...(element.dataset?.[`statusClasses${statusClassKey}`]?.split(" ") || []));
      });
    },
  });
}
